import { useDispatch, useSelector } from "react-redux";
import { Container, Grid, Box, Typography  } from "@mui/material";

import Input from "@/components/ph/Input";

import FormSection from "../../utils/FormSection";

import { setFormValue } from "../contractorSlice";

const ContractorContact = () => {
  const dispatch = useDispatch();

  const formValues = useSelector((state) => state.contractor.formValues);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setFormValue({ field: name, value }));
  };

  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
      <FormSection>
        <Grid container spacing={2} size={{ xs: 12, md: 12 }}>
            <Grid size={{ xs: 12, md: 12 }}>
                <Typography
                variant="body1"
                sx={{
                    color: "text.secondary",
                    mt: 1,
                    mb: 1,
                    fontSize: "1rem",
                    fontWeight: "500",
                }}
                >
                DATOS DE CONTACTO DEL CONTRATANTE
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                <Input
                    errorMessage="El nombre es un campo  requerido"
                    label="Correo Electrónico"
                    name="correoElectronico"
                    value={formValues.correoElectronico}
                    onChange={handleChange}
                    required
                    disabled
                    type="text"
                />
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
                <Input
                    errorMessage="El nombre es un campo  requerido"
                    label="Teléfono Móvil (10 digitos)"
                    name="telefonoMovil"
                    value={formValues.telefonoMovil}
                    onChange={handleChange}
                    required
                    disabled
                    type="text"
                />
                </Box>
            </Grid>
        </Grid>
      </FormSection>
    </Container>
  );
};

export default ContractorContact;
